// extracted by mini-css-extract-plugin
module.exports = {"table":"reportSaleDetail_table__3onJj"};